import React, { useCallback, useState } from 'react';
import { Upload } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './UploadDropzone.css';

export function UploadDropzone({ onUpload, accept, maxFiles, className = '' }) {
  const { t } = useTranslation();
  const [isDragging, setIsDragging] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    
    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0 && onUpload) {
      onUpload(files);
    }
  }, [onUpload]);

  const handleFileSelect = useCallback((e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0 && onUpload) {
      onUpload(files);
    }
    // Reset input
    e.target.value = '';
  }, [onUpload]);

  return (
    <div className={`upload-dropzone ${className}`}>
      <div
        className={`upload-dropzone__area ${isDragging ? 'upload-dropzone__area--dragging' : ''}`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <input
          type="file"
          multiple={!maxFiles || maxFiles > 1}
          accept={accept}
          onChange={handleFileSelect}
          className="upload-dropzone__input"
        />
        <Upload size={48} className="upload-dropzone__icon" />
        <h4 className="upload-dropzone__title">{t('reports.workspace.documents.dropzone.title')}</h4>
        <p className="upload-dropzone__subtext">
          {t('reports.workspace.documents.dropzone.hint')}
        </p>
      </div>
      
      {uploadProgress > 0 && uploadProgress < 100 && (
        <div className="upload-dropzone__progress">
          <div 
            className="upload-dropzone__progress-fill"
            style={{ width: `${uploadProgress}%` }}
          />
        </div>
      )}
    </div>
  );
}


